(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yarntons-promotions"]) return;
  try {
    
  (function () {
    function initTrack(track) {
      if (track.dataset.promoInit) return;
      track.dataset.promoInit = 'true';

      var root = track.closest('.ynt-promo');
      if (!root) return;

      var prevBtn = root.querySelector('[data-promo-prev]');
      var nextBtn = root.querySelector('[data-promo-next]');
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function step() {
        var tile = track.querySelector('.ynt-promo__tile');
        var gap = parseFloat(window.getComputedStyle(track).columnGap) || 16;
        return tile ? tile.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      }

      function updateNav() {
        if (!prevBtn || !nextBtn) return;
        var max = track.scrollWidth - track.clientWidth - 2;
        prevBtn.disabled = track.scrollLeft <= 2;
        nextBtn.disabled = track.scrollLeft >= max;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' });
        });
      }

      track.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-promo-track]').forEach(initTrack);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
